import { http } from 'common/helpers/axios/axios-helper';
import { DepartamentsModel as Model } from '../model/departaments.model';
import DepartmentRequestDeleteViewModel from '../model/department-request-delete.model';

const basePath = '/department';

async function getDataList(status: string) {
  const queryParams = [];

  if (status !== undefined && status !== '') {
    queryParams.push(`IsActive=${status}`);
  }

  const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : '';
  return await http.get<Model[]>(`${basePath}${queryString}`);
}

async function getDataById(id: any) {
  return await http.get<Model>(`${basePath}/${id}`);
}

async function postData(data: Model) {
  return await http.post<Model>(`${basePath}`, data);
}

async function putData(data: Model) {
  return await http.put<Model>(`${basePath}/${data.id}`, data);
}

async function deleteDataById(id: any) {
  return await http.del(`${basePath}/${id}`);
}

async function requestDeleteDataById(id: any) {
  return await http.post<DepartmentRequestDeleteViewModel>(`${basePath}/requestdelete/${id}`, {});
}

export const DepartamentsService = { getDataList, getDataById, postData, putData, deleteDataById, requestDeleteDataById };
